/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react';
import LabeledInputWithBlur from '../../../../sharedmodules/components/form-fields/labeled-input-with-blur';
import PropTypes from 'prop-types';

const PinSearchInputField = ({ handleExecute, handleReset }) => {

    const [pinDetails, setPinDetails] = useState({ pin: '' });
    const isVsrError = '';

    const [fieldTouch, setFieldTouched] = useState({
        pin: false,
    });

    const handleInputChange = (e) => {

        e.preventDefault();
        setPinDetails({
            ...pinDetails,
            [e.target.name]: e.target.value,
        });
        setFieldTouched({
            ...fieldTouch,
            [e.target.name]: true,
        });

    };

    const isValidDetails = (fieldTouchValue, pinDetailsValue) => (fieldTouchValue && pinDetailsValue !== '') || !fieldTouchValue;

    const validateExecuteButton = () => pinDetails.pin === '';

    return (
        <div className="dealer-settings-body">
            <div className="input-details">
                <div className="input-fields">
                    <LabeledInputWithBlur
                        className="user-id"
                        name="pin"
                        errorMessage="PIN_IS_REQUIRED"
                        highlightClass={isValidDetails(fieldTouch.pin, pinDetails.pin) ? '' : 'highlight-error'}
                        isEditable
                        isValid={isValidDetails(fieldTouch.pin, pinDetails.pin)}
                        label="PIN"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        value={pinDetails.pin}
                        vsrMessage={isVsrError}
                    />
                </div>
            </div>
            <div className="button-layout">
                <button
                    type="button"
                    onClick={() => {

                        setPinDetails({ pin: '' }); handleReset();

                    }}
                >

Reset
                </button>
                <button type="button" id="execute" onClick={() => handleExecute(pinDetails)} disabled={validateExecuteButton()}>

Execute
                </button>
            </div>
        </div>

    );

};

PinSearchInputField.propTypes = {
    handleExecute: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
};

export default PinSearchInputField;
